import {BrowserRouter as Router, Routes, Route, Navigate} from "react-router-dom";
import Home from "./pages/Home";
import ChatBotLanding from "./components/ChatBotLanding";
import ChatBotChat from "./components/ChatBotChat";

function App() {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<Home />}>
              <Route index element={<Navigate to="new-chat" replace />} />
              <Route path="new-chat" element={<ChatBotLanding />} />
              <Route path="chat/:chat_id" element={<ChatBotChat />} />
          </Route>
        </Routes>
      </Router>
  )
}

export default App;
